import { Image } from "react-bootstrap";

import logo_footer from '../../assets/img/logo_footer.png';


function Footer() {
    return(
        <footer id="wrap-footer" class="color-w">
            <div class="footer-top">
                <div class="container">
                    <div class="row">
                        <div id="footer_info">
                            <Image src={logo_footer}></Image>
                            <p>
                                322 S. 6th St. Griffin, GA 30224
                                <br /> 770.233.1159
                                <br />
                                <a href="mailto:markblair@assisteddiningsolutions.com">markblair@assisteddiningsolutions.com</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <div class="container">
                    <p>Site by <a href="http://www.stonesouptech.com" target="_blank" rel="noreferrer">Stone Soup</a></p>
                </div>
            </div>

        </footer>
    );
}

export default Footer;